export enum CounterBalancingGroup {
  GROUP_A = 'GroupA',
  GROUP_B = 'GroupB',
}
